import './Build.css';

const BUILD_LOG = [
  { ver: 'v0.3.2', msg: 'Batch OCR processing' },
  { ver: 'v0.3.1', msg: 'Hindi model accuracy improved' },
  { ver: 'v0.3.0', msg: 'Auto-tagging engine live' },
  { ver: 'v0.2.8', msg: 'Tag confidence scoring' },
  { ver: 'v0.2.5', msg: 'Background memory usage −40%' },
];

const BUILD_LINKS = [
  { label: '@brrocode on X', href: 'https://x.com/brrocode' },
  { label: 'GitHub',          href: 'https://github.com/vijay4dev' },
  { label: 'Portfolio',       href: 'https://brrocodeportfolio.online/' },
];

export default function Build() {
  return (
    <section className="build" id="build">
      <div className="build-inner">
        <div>
          <div className="build-label reveal">Build log</div>
          <div className="build-log reveal">
            {BUILD_LOG.map((e, i) => (
              <div className="build-entry" key={i}>
                <span className="build-ver">{e.ver}</span>
                <span className="build-arrow">→</span>
                <span className="build-msg">{e.msg}</span>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="build-label reveal">Follow the build</div>
          <div className="build-links reveal">
            {BUILD_LINKS.map((l, i) => (
              <a
                key={i}
                href={l.href}
                className="build-link"
                target="_blank"
                rel="noreferrer"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
